import * as p5 from "p5";
window.p5 = p5;